// src/services/api.js
import axios from 'axios';
import { localizeServerMessage } from '../utils/serverError';

// عنوان الـAPI من البيئة (مع افتراضي يطابق الباكند لديك)
export const apiBaseURL =
  process.env.REACT_APP_API_URL || 'http://localhost:3360';

const api = axios.create({
  baseURL: apiBaseURL,
  withCredentials: false, // لا نستخدم كوكيز حالياً
  timeout: 15000,
  headers: {
    Accept: 'application/json',
  },
});

// اعتراض واحد لإضافة التوكن و الـrole للدخول
api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem('token') || localStorage.getItem('access_token');
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    const roleId = localStorage.getItem('role_id');
    if (roleId) {
      config.headers = config.headers ?? {};
      config.headers['X-ROLE-ID'] = roleId;
    }

    // Content-Type افتراضي للطلبات JSON إن لم يُضبط
    if (
      !config.headers['Content-Type'] &&
      config.data &&
      typeof config.data === 'object' &&
      !(config.data instanceof FormData)
    ) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// T5: تجديد صامت للجلسة عند 401 — يحلّ جذر أخطاء انتهاء التوكن (ساعة واحدة).
// عند 401 نجدّد access token عبر /refresh مرّة واحدة ثم نعيد الطلب الأصلي.
let refreshPromise = null; // single-flight: طلب تجديد واحد يخدم كل الطلبات المتزامنة

function doRefresh() {
  if (!refreshPromise) {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) return Promise.reject(new Error('no_refresh_token'));
    // axios خام (بلا interceptor) لتفادي التكرار اللانهائي
    refreshPromise = axios
      .post(`${apiBaseURL}/refresh`, { refresh_token: refreshToken }, { timeout: 15000 })
      .then((res) => {
        const newToken = res?.data?.token;
        if (!newToken) throw new Error('no_token_in_refresh');
        localStorage.setItem('token', newToken);
        if (res.data.refresh_token) {
          localStorage.setItem('refresh_token', res.data.refresh_token);
        }
        return newToken;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

function forceLogout() {
  ['token', 'refresh_token', 'userId', 'userName', 'role_id', 'is_system_admin', 'permissions', 'owner_id', 'me_menu', 'app_menu_all']
    .forEach((k) => localStorage.removeItem(k));
  if (typeof window !== 'undefined' && !/\/login$/.test(window.location.pathname)) {
    window.location.assign('/login');
  }
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error?.config || {};
    const status = error?.response?.status;
    const url = String(original.url || '');
    const isAuthEndpoint = /\/(login|refresh)$/.test(url);

    if (status === 401 && !original._retry && !isAuthEndpoint) {
      original._retry = true;
      try {
        const newToken = await doRefresh();
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original); // أعِد الطلب الأصلي بالتوكن الجديد
      } catch (e) {
        forceLogout(); // فشل التجديد (refresh منتهٍ/غير موجود) → خروج نظيف
        return Promise.reject(error);
      }
    }
    // 3.4.4: ترجمة رسالة الخادم مركزيًّا إلى لغة المستخدم قبل أن تعرضها الصفحات.
    const data = error?.response?.data;
    if (data && typeof data.message === 'string') {
      data.message = localizeServerMessage(data.message);
    }
    return Promise.reject(error);
  }
);

export default api;
